// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import DynamicFormFieldPayloadResourceViewModel from '../../../../viewModel/resource/DynamicFormFieldPayloadResourceViewModel';
import DynamicFormFieldPayloadResourceDTO from '../../dto/resource/DynamicFormFieldPayloadResourceDTO';

export default abstract class DynamicFormFieldPayloadResourceModel extends BaseModel<DynamicFormFieldPayloadResourceDTO> {
  /**
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get values() { return this.dto.values; }
  set values(value) { this.dto.values = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
  }
}
